// Represents a DB table or combination of DB tables in super service
const _ResourceGlobal = {
  Account: "accounts",
  AccountOverageNotification: "account_overage_notifications",
  AccountRegion: "account_regions",
  AccountUserCount: "account_user_counts",
  AdminRoleMembership: "admin_role_memberships",
  AdminUser: "admin_users",
  ApiKey: "api_keys",
  CanceledEnterpriseOwner: "canceled_enterprise_users",
  CanceledInAppPurchaseUser: "canceled_in_app_purchase_users",
  CanceledStripeOwner: "canceled_stripe_users",
  Charge: "charges",
  Company: "companies",
  EnterprisePlan: "enterprise_plans",
  EnterprisePlanInvoice: "enterprise_plan_invoices",
  InAppPurchase: "in_app_purchases",
  JobInfo: "job_infos",
  OtcMaintenanceWindow: "otc_maintenance",
  PayingEnterpriseOwner: "paying_enterprise_users",
  PayingInAppPurchaseUser: "paying_in_app_purchase_users",
  PayingStripeOwner: "paying_stripe_users",
  SsoInfo: "sso_infos",
  StripeSubscription: "stripe_subscriptions",
  User: "users",
} as const;

export const ResourceGlobal = _ResourceGlobal;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ResourceGlobal =
  (typeof _ResourceGlobal)[keyof typeof _ResourceGlobal];

const RESOURCE_GLOBAL_VALUES = new Set<string>(Object.values(ResourceGlobal));

export function isResourceGlobal(value: string): value is ResourceGlobal {
  return RESOURCE_GLOBAL_VALUES.has(value);
}
